import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    getLaboratoryOrders,
    getPharmacyOrders,
    setLabActiveTile,
    setPharmacyActiveTile
} from '../../../../redux/actions/dashboard';
import TileItem from './TileItem';
import {getVendorType} from "../../../../services/auth";

const TopTiles = (props) => {
    const dispatch = useDispatch();
    const {tiles} = props;
    const vendor_type = getVendorType();
    const {lab_active_tile, pharmacy_active_tile} = useSelector((state) => state.dashboard);
    const getActiveTile = () => {
        switch (vendor_type){
            case 'LAB':
                return lab_active_tile;
            case 'HOME_CARE':
                return lab_active_tile;
            case 'DRUG':
                return pharmacy_active_tile;
            default:
                return '';
        }
    };
    const getActiveTileSetter = (name) => {
        switch (vendor_type){
            case 'LAB':
                return setLabActiveTile(name);
            case 'HOME_CARE':
                return setLabActiveTile(name);
            case 'DRUG':
                return setPharmacyActiveTile(name);
            default:
                return setLabActiveTile(name);
        }
    };
    return(
        <div className="tiles-holder">
            {
                tiles.map((tile,index) => {
                    return <TileItem tile={tile} key={index} active={tile.name === getActiveTile()} onClick={() => {
                        dispatch(getActiveTileSetter(tile.name))
                        dispatch(vendor_type === 'DRUG' ? getPharmacyOrders() : getLaboratoryOrders());
                    }} />
                })
            }
        </div>
    )
};

export default TopTiles;